import React, { useEffect } from "react";
import { Box } from "theme-ui";
import { ActionBanner, Testimonial } from "../molecules";
import { navigate, useLocation } from "@reach/router";

const TestimonialSection = ({ testimonial }) => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });
  }, []);

  return (
    <Box>
      <ActionBanner
        variant="BodyBannerV6"
        theme="primary"
        title={
          <>
            Evaluating our pricing?
            <br />
            We’ll take the price challenge!"
          </>
        }
        desc="Our customers endorse we offer exceptional software and service at unchallenged prices. Our costs per license are the lowest in our category."
        primaryBtnLabel="Plans and pricing"
        primaryBtnId="home_plans_and_pricing_in_btn"
        onPrimaryButtonClick={() => navigate("/pricing/")}
        secondaryBtnLabel="Discuss pricing"
        secondaryBtnId="home_discuss_pricing_in_btn"
        onSecondaryButtonClick={() => navigate("/demo/?utm_source=%2Fhome")}
        testimonial="true"
        customStyles={{
          mb: 0,
        }}
      >
        <Testimonial
          employeeDesignation={testimonial?.employeeDesignation}
          employeeName={testimonial?.employeeName}
          feedback={testimonial?.feedback}
          rating={testimonial?.rating}
          imageUrl={
            testimonial?.testimonialImage?.gatsbyImageData?.images?.fallback
              ?.src
          }
          imageAltText={testimonial?.testimonialImageAltText}
          companyLogoUrl={
            testimonial?.companyLogo?.gatsbyImageData?.images?.fallback?.src
          }
          companyLogoAltText={testimonial?.companyLogoAltText}
          reviewUrl={testimonial?.slug}
        />
      </ActionBanner>
    </Box>
  );
};

export default TestimonialSection;
